/**
 * 设备错误码枚举
 */
export enum DeviceErrorCode {
  /** 环境不支持 (e.g. WebHID 不可用) */
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  /** 设备未连接或已断开 */
  NOT_CONNECTED = 'NOT_CONNECTED',
  /** 打开设备失败 */
  OPEN_FAILED = 'OPEN_FAILED',
  /** 发送指令失败 */
  WRITE_FAILED = 'WRITE_FAILED',
  /** 读取数据失败 */
  READ_FAILED = 'READ_FAILED',
  /** 操作超时 */
  TIMEOUT = 'TIMEOUT',
  /** 参数无效 */
  INVALID_PARAM = 'INVALID_PARAM',
  /** 当前版本不支持 */
  NOT_SUPPORTED_VERSION = 'NOT_SUPPORTED_VERSION',
  /** 已达上限 */
  MAX_LIMIT_REACHED = 'MAX_LIMIT_REACHED',
  /** 未知错误 */
  UNKNOWN = 'UNKNOWN',
}

/** 传输层错误码：通道不可用、读写失败、超时等（非业务参数错误） */
const TRANSPORT_ERROR_CODES: ReadonlySet<DeviceErrorCode> = new Set([
  DeviceErrorCode.NOT_CONNECTED,
  DeviceErrorCode.OPEN_FAILED,
  DeviceErrorCode.WRITE_FAILED,
  DeviceErrorCode.READ_FAILED,
  DeviceErrorCode.TIMEOUT,
])

/**
 * 是否为设备传输层错误（休眠、断连、通道读写失败等）
 */
export function isTransportDeviceError(error: unknown): boolean {
  return error instanceof DeviceError && TRANSPORT_ERROR_CODES.has(error.code)
}

/**
 * 设备错误类
 * 统一封装 SDK 抛出的所有异常
 */
export class DeviceError extends Error {
  /** 错误码 */
  public readonly code: DeviceErrorCode
  /** 原始错误 (可选) */
  public readonly originalError?: unknown

  constructor(code: DeviceErrorCode, message: string, originalError?: unknown) {
    super(message)
    this.name = 'DeviceError'
    this.code = code
    this.originalError = originalError

    // 修复 TypeScript 中继承 Error 的原型链问题
    Object.setPrototypeOf(this, DeviceError.prototype)

    this.setLocalizedMessage()
  }

  setLocalizedMessage(): void {
    if (typeof window !== 'undefined') {
      window?.electronAPI?.sendLog(this.toString(), 'DeviceError')
    }
  }

  /**
   * 转换为易读的字符串
   */
  public toString(): string {
    return `[DeviceError${new Date().toISOString()}: ${this.code}] ${this.message}`
  }
}
